module.exports = __webpack_public_path__ + "img/fire-emblem.6b13dae3.png";